var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: { width: _vm.$isMobile() ? "100%" : "900px" },
          model: {
            value: _vm.show,
            callback: function ($$v) {
              _vm.show = $$v
            },
            expression: "show",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "invoice-review-modal", attrs: { flat: "" } },
            [
              _c(
                "v-card-title",
                [
                  _vm._v("\n        Detalhes da nota fiscal\n        "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c("v-icon", { on: { click: _vm.close } }, [
                    _vm._v("\n          close\n        "),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _vm.isLoading
                ? _c("AppLoadingIcon", { attrs: { color: "#BBB" } })
                : _vm.invoice
                ? [
                    _c("div", { staticClass: "irm-invoice-details" }, [
                      _c("div", { staticClass: "irm-id-company-seller" }, [
                        _c("div", { staticClass: "irm-id-item" }, [
                          _c("p", [
                            _vm._v("\n                NFe: "),
                            _c("b", [
                              _vm._v(_vm._s(_vm.invoice.invoiceNumber)),
                            ]),
                            _vm._v(" Série: "),
                            _c("b", [_vm._v(_vm._s(_vm.invoice.serialNumber))]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "gray--text text--lighten-1" },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.invoice.company) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "irm-id-item" }, [
                          _c(
                            "p",
                            { staticClass: "gray--text text--lighten-1" },
                            [
                              _vm._v(
                                "\n                Vendedor\n              "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.invoice.seller) +
                                "\n              "
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "irm-id-item" },
                        [
                          _c("InvoiceStatus", {
                            attrs: {
                              status: _vm.invoice.lastValidationStatus,
                              "refusal-reasons": _vm.invoice.refusalReason,
                              label: "Status Validação",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "irm-id-item" }, [
                        _c("p", { staticClass: "gray--text text--lighten-1" }, [
                          _vm._v("\n              Nota\n            "),
                        ]),
                        _vm._v(" "),
                        _c("p", [_vm._v("\n              1/1\n            ")]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("v-data-table", {
                      staticClass: "table-container",
                      attrs: {
                        items: _vm.invoice.products,
                        headers: _vm.headers,
                        "item-key": "_id",
                        "hide-actions": "",
                        "disable-initial-sort": "",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "items",
                          fn: function (props) {
                            return [
                              _c("tr", [
                                _c("td", { attrs: { width: "40%" } }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-inline-flex align-center",
                                    },
                                    [
                                      props.item.toReview
                                        ? _c("v-checkbox", {
                                            attrs: {
                                              "input-value": true,
                                              disabled: "",
                                              "hide-details": "",
                                            },
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "mb-0" }, [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(props.item.description) +
                                            "\n                  "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        props.item.partnersPremiumQuantity
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(
                                        `${props.item.invoiceQuantity}/${props.item.invoiceUnity}`
                                      ) +
                                      "\n              "
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _c(
                                    "div",
                                    { staticClass: "product-status" },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          staticClass: "mr-2",
                                          class: _vm.status(props.item).color,
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.status(props.item).type
                                              ) +
                                              "\n                  "
                                          ),
                                        ]
                                      ),
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(_vm.status(props.item).text) +
                                          "\n                "
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _vm.invoice.notAgreeWith
                      ? _c("div", { staticClass: "irm-not-agree-with" }, [
                          _c(
                            "div",
                            { staticClass: "d-inline-flex align-center" },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  "input-value":
                                    _vm.invoice.notAgreeWith.dmProduct,
                                  disabled: "",
                                  "hide-details": "",
                                },
                              }),
                              _vm._v(" "),
                              _c("p", { staticClass: "mb-0" }, [
                                _vm._v(
                                  "\n              Produto da Campanha\n            "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-inline-flex align-center" },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  "input-value":
                                    _vm.invoice.notAgreeWith.quantity,
                                  disabled: "",
                                  "hide-details": "",
                                },
                              }),
                              _vm._v(" "),
                              _c("p", { staticClass: "mb-0" }, [
                                _vm._v(
                                  "\n              Quantidade calculada\n            "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-inline-flex align-center" },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  "input-value":
                                    _vm.invoice.notAgreeWith.status,
                                  disabled: "",
                                  "hide-details": "",
                                },
                              }),
                              _vm._v(" "),
                              _c("p", { staticClass: "mb-0" }, [
                                _vm._v(
                                  "\n              Situação\n            "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "mx-4 gray--text text--lighten-1" },
                      [_vm._v("Motivo da revisão")]
                    ),
                    _vm._v(" "),
                    _c("textarea", {
                      staticClass: "irm-reason",
                      attrs: { type: "text", rows: "3", disabled: "" },
                      domProps: { value: _vm.invoice.reviewDescription },
                    }),
                    _vm._v(" "),
                    _vm.invoice.files.length
                      ? _c(
                          "div",
                          { staticClass: "irm-files" },
                          _vm._l(_vm.invoice.files, function (file) {
                            return _c(
                              "a",
                              { attrs: { href: file.path, target: "_blank" } },
                              [
                                _c(
                                  "span",
                                  { staticClass: "d-flex" },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-2",
                                        attrs: { medium: "" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                open_in_new\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", [
                                      _c("p", { staticClass: "mb-0" }, [
                                        _c("b", [
                                          _vm._v(_vm._s(file.filename)),
                                        ]),
                                      ]),
                                      _vm._v(" "),
                                      _c("p", { staticClass: "mb-0" }, [
                                        _vm._v("Clique para visualizar"),
                                      ]),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.invoice.reviewStatus === "pending"
                      ? _c(
                          "div",
                          { staticClass: "pa-4 text-xs-right" },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "ma-0 mr-2",
                                attrs: {
                                  color: "primary",
                                  outline: "",
                                  large: "",
                                },
                                on: { click: _vm.reprove },
                              },
                              [
                                _vm._v(
                                  "\n            Reprovar solicitação\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                staticClass: "ma-0",
                                attrs: { color: "primary", large: "" },
                                on: { click: _vm.approve },
                              },
                              [
                                _vm._v(
                                  "\n            Aprovar solicitação\n          "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.invoice
        ? [
            _c(
              "ReproveInvoiceReviewModal",
              _vm._g(
                {
                  ref: "reproveInvoiceReviewModal",
                  attrs: { "review-id": _vm.invoice.reviewId },
                  on: {
                    close: function ($event) {
                      _vm.show = true
                    },
                  },
                },
                _vm.$listeners
              )
            ),
            _vm._v(" "),
            _c(
              "ApproveInvoiceReviewModal",
              _vm._g(
                {
                  ref: "approveInvoiceReviewModal",
                  attrs: { "review-id": _vm.invoice.reviewId },
                  on: {
                    close: function ($event) {
                      _vm.show = true
                    },
                  },
                },
                _vm.$listeners
              )
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }